import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { adminConditionsAPI } from '../services/api';
import './Users.css';

const Conditions = () => {
  const navigate = useNavigate();
  const [conditions, setConditions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void loadConditions();
  }, []);

  const loadConditions = async () => {
    setLoading(true);
    try {
      const response = await adminConditionsAPI.getAll();
      const list = response.data?.conditions || [];
      setConditions(list);
    } catch (error) {
      console.error('Error loading conditions:', error);
      toast.error('Error loading conditions: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  if (loading && conditions.length === 0) {
    return <div className="loading">Loading conditions...</div>;
  }

  return (
    <div className="users-container">
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Key</th>
              <th>Display name</th>
              <th>Color</th>
              <th>Arabic</th>
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!loading && conditions.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                  No conditions found
                </td>
              </tr>
            ) : (
              conditions.map((c) => (
                <tr key={c.id}>
                  <td>{c.name || 'N/A'}</td>
                  <td>{c.display_name || 'N/A'}</td>
                  <td>
                    <span
                      style={{
                        display: 'inline-block',
                        width: 28,
                        height: 20,
                        borderRadius: 4,
                        backgroundColor: c.background_color || '#f0f0f0',
                        border: '1px solid rgba(0,0,0,0.12)',
                        verticalAlign: 'middle',
                      }}
                      title={c.background_color || '—'}
                    />
                    <span style={{ marginLeft: 8, fontSize: 12, color: '#666' }}>
                      {c.background_color || '—'}
                    </span>
                  </td>
                  <td>{c.display_name_ar || '—'}</td>
                  <td>{c.is_active ? 'Yes' : 'No'}</td>
                  <td className="actions">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => navigate(`/conditions/${c.id}/edit`)}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <p style={{ marginTop: '16px', fontSize: '13px', color: '#666' }}>
        <Link to="/dashboard">← Back to dashboard</Link>
      </p>
    </div>
  );
};

export default Conditions;
